import React from 'react';

interface PaymentPlanButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  actionName?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'blue';
}

const PaymentPlanButton: React.FC<PaymentPlanButtonProps> = ({ 
  text, 
  onClick, 
  disabled = false, 
  actionName = 'Payment Plan Button',
  icon,
  variant = 'blue'
}) => {
  const baseClasses = "font-light transition duration-300 underline flex items-center space-x-2 text-xs";
  const variantClasses = variant === 'blue' 
    ? 'text-blue-600 hover:text-blue-700' 
    : 'text-gray-700 hover:text-gray-900';
  const disabledClasses = disabled ? 'cursor-default opacity-50' : 'cursor-pointer';
  const iconClasses = icon ? 'space-x-2' : '';

  return (
    <button
      onClick={(e) => { 
        e.stopPropagation(); 
        if (!disabled) onClick(); 
      }} 
      disabled={disabled}
      className={`${baseClasses} ${variantClasses} ${disabledClasses} ${iconClasses}`}
      data-dd-action-name={actionName}
    >
      {icon && icon}
      <span>{text}</span>
    </button>
  );
};

export default PaymentPlanButton; 